import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';


import App from './App.vue';

import Home from './view/homeVue.vue';
import Animaux from './view/animauxVue.vue';
import Legal from './view/legalVue.vue';
import Sos from './view/sosVue.vue';
import Ferme from './view/FermeVue.vue';
import Service from './view/serviceVue.vue';


import Adopter from './view/adopteVue.vue';
import Partenaire from './view/partenaireVue.vue';
import Shops from './view/shopVue.vue';
import Besoins from './view/besoinsVue.vue';
import Information from './view/informationVue.vue';
import Actu from './view/actuVue.vue';
import AnimalPage from './view/animauxDetails.vue';
import NewsPage from './view/newsPage.vue';
import Signalement from './view/signalementVue.vue';
import Fourriere from './view/fourriereVue.vue';
import Faq from './view/faqVue.vue';
import Benevole from './view/benevoleVue.vue';
import Cec from './view/cecVue.vue';
import Tarif from './view/tarifsVue.vue';
import InfoRefuge from './view/infoRefuge.vue';
import Contact from './view/contactVue.vue';
import Dons from './view/donVue.vue';
import ContentPage from './view/contentPage.vue';

// ══════════════════════════════════════════════
// ▼▼▼  CONFIGURATION DU SITE — tout modifier ici  ▼▼▼
// ══════════════════════════════════════════════
const _short = "Les Oubliés de la Run"; // nom court
const _full = "Les Oubliés de la Run"; // nom complet
const _loc = "La Réunion"; // département / région
// ══════════════════════════════════════════════

const _alt = `association de protection animale ${_short} ${_loc}`;

export const SEO = {
    idSite: 26,
    shortName: _short,
    fullName: _full,
    location: _loc,
    altSuffix: _alt,
    siteName: _short,
    defaultTitle: `${_short} | Association de protection animale à ${_loc}`,
    defaultDescription: `${_short} est une association de protection animale à ${_loc}. Adoptez un animal, devenez famille d'accueil ou soutenez notre association bénévole.`,
    faviconUrl: "https://admin.asso-refuge.fr/images/1757358341_logo.jpg",
    googleAnalyticsId: "G-VWM4BD1BM2", // ← ID Google Analytics à mettre à jour

    // Réseaux sociaux — laisser null pour masquer le lien
    social: {
        facebook: null, // ← à mettre à jour avec le lien Facebook de l'association
        youtube: null,
    },

    // SEO par page : title + description
    pages: {
        '/': {
            title: `${_short} | Association de protection animale à ${_loc}`,
            description: `${_short} sauve et place des animaux en famille à ${_loc}. Adoptez un animal, devenez famille d'accueil ou soutenez notre association bénévole.`,
        },
        '/animaux': {
            title: `Animaux à adopter | ${_short}`,
            description: `Chiens et chats à adopter à ${_loc}. Consultez tous les animaux disponibles placés en famille d'accueil par ${_short}.`,
        },
        '/adopte': {
            title: `Les adoptés | ${_short}`,
            description: `Découvrez les animaux qui ont trouvé une famille grâce à ${_short} à ${_loc}. Histoires de sauvetage et d'adoption réussie.`,
        },
        '/besoins': {
            title: `Nos besoins | ${_short}`,
            description: `Aidez ${_short} à ${_loc} : dons de matériel, nourriture et bénévolat. Chaque geste compte pour les animaux sauvés par notre association.`,
        },
        '/sos': {
            title: `SOS Animaux | ${_short}`,
            description: `Signalez un animal en danger ou en détresse à ${_loc}. ${_short} intervient pour secourir les animaux abandonnés ou maltraités.`,
        },
        '/contact': {
            title: `Contact | ${_short}`,
            description: `Contactez ${_short}, association de protection animale à ${_loc}. Adoption, bénévolat, signalement, famille d'accueil.`,
        },
        '/partenaires': {
            title: `Nos partenaires | ${_short}`,
            description: `Découvrez les partenaires vétérinaires et associations qui soutiennent ${_short} pour la protection animale à ${_loc}.`,
        },
        '/actualites': {
            title: `Actualités | ${_short}`,
            description: `Toutes les actualités de ${_short} à ${_loc} : sauvetages, adoptions réussies, événements et nouvelles de notre association.`,
        },
        '/faq': {
            title: `FAQ — Questions fréquentes | ${_short}`,
            description: `Toutes les réponses à vos questions sur l'adoption, les familles d'accueil et le fonctionnement de ${_short} à ${_loc}.`,
        },
        '/dons': {
            title: `Faire un don | ${_short}`,
            description: `Soutenez ${_short} par un don financier ou matériel. Votre contribution aide directement les animaux sauvés par notre association bénévole à ${_loc}.`,
        },
        '/legal': {
            title: `Mentions légales | ${_short}`,
            description: `Mentions légales du site officiel de ${_short}, association loi 1901 de protection animale à ${_loc}.`,
        },
        '/qui-sommes-nous': {
            title: `Qui sommes-nous | ${_short}`,
            description: `${_short} : association bénévole de protection animale à ${_loc}. Histoire, missions, équipe et actions.`,
        },
        '/shops': {
            title: `Boutique solidaire | ${_short}`,
            description: `Boutique solidaire de ${_short}. Chaque achat soutient directement les animaux sauvés et placés en famille d'accueil à ${_loc}.`,
        },
        '/signalement': {
            title: `Signaler une maltraitance animale | ${_short}`,
            description: `Signalez un cas de maltraitance ou d'abandon d'animal à ${_loc}. ${_short} prend en charge et alerte les autorités compétentes.`,
        },
        '/recherche_famille': {
            title: `Recherche famille d'accueil | ${_short}`,
            description: `Devenez famille d'accueil pour ${_short} à ${_loc}. Hébergez temporairement un animal en attente d'adoption et aidez notre association bénévole.`,
        },
        // Pages dynamiques issues de l'API (getPagess/26)
        '/page/29': {
            title: `Présentation | ${_short}`,
            description: `Découvrez l'histoire et les missions de ${_short}, association de protection animale à ${_loc}.`,
        },
        '/page/30': {
            title: `Conditions d'adoption | ${_short}`,
            description: `Découvrez les conditions et les étapes pour adopter un animal via ${_short} à ${_loc}. Frais d'adoption, visite de contrôle, contrat d'adoption.`,
        },
        '/page/31': {
            title: `Nos besoins | ${_short}`,
            description: `Consultez les besoins matériels et humains de ${_short} à ${_loc}. Dons, bénévolat, familles d'accueil : plusieurs façons d'aider notre association.`,
        },
    },
};

const routes = [
    { path: '/redirect', redirect: '/' },
    { path: '/', component: Home },
    { path: '/partenaires', component: Partenaire },
    { path: '/faq', component: Faq },
    { path: '/shops', component: Shops },
    { path: '/besoins', component: Besoins },
    { path: '/sos', component: Sos },
    { path: '/actualites', component: Actu },
    { path: '/animaux_ferme', component: Ferme },
    { path: '/actions', component: Service },
    { path: '/animaux_trouve', component: Fourriere },
    { path: '/benevolat', component: Benevole },
    { path: '/adopte', component: Adopter },
    { path: '/legal', component: Legal },
    { path: '/info_refuge', component: Information },
    { path: '/animaux', component: Animaux },
    { path: '/signalement', component: Signalement },
    { path: '/dons', component: Dons },
    { path: '/cec', component: Cec },
    { path: '/contact', component: Contact },
    { path: '/qui-sommes-nous', component: InfoRefuge },
    { path: '/tarifs', component: Tarif },
    { path: '/publication/:id', component: NewsPage },
    { path: '/animaux/:id', component: AnimalPage },
    { path: '/page/:id', component: ContentPage },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }

        if (to.hash) {
            return new Promise((resolve) => {
                // Attendre un peu que la page soit rendue et que l'ancre existe,
                // surtout lors d'une navigation vers '/' depuis une autre page.
                setTimeout(() => {
                    resolve({ el: to.hash, behavior: 'smooth' });
                }, 250);
            });
        }

        return { top: 0 };
    },
});

// Mise à jour dynamique du titre et de la meta description à chaque navigation
router.afterEach((to) => {
    const pageSeo = SEO.pages[to.path] || {};
    document.title = pageSeo.title || SEO.defaultTitle;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
        metaDesc.setAttribute('content', pageSeo.description || SEO.defaultDescription);
    }
});

// Créer l'application Vue
const app = createApp(App);
app.config.globalProperties.$idSite = SEO.idSite;
app.config.globalProperties.$seo = SEO;

// Utiliser le routeur
app.use(router);

// Monter l'application
app.mount('#app');